import QueryString from 'qs';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getRegisterUser } from '../api/orderHistory';
import { handlePostMessage } from '../js/postMessage';
import { getParsedLocalStorageItem } from '../js/script';
import { imgURL } from './Home';
import { useCommonContext } from '../components/provider/CommonProvider';

export default function MypayReady() {
  const formRef = useRef<HTMLFormElement>(null);
  const [myPayData, setMyPayData] = useState<any>();
  const [paylogos, setPayLogos] = useState<any>();
  const { setIsLottie } = useCommonContext();
  const location = useLocation();
  const navigate = useNavigate();
  const handleSubmit = () => {
    const form = formRef.current;
    if (form) {
      const url = form.action;
      const formData = new FormData(form);

      const newForm = document.createElement('form');
      newForm.method = 'POST';
      newForm.action = url;

      formData.forEach((value, key) => {
        const hiddenField = document.createElement('input');
        hiddenField.type = 'hidden';
        hiddenField.name = key;
        hiddenField.value = value.toString();
        newForm.appendChild(hiddenField);
      });

      document.body.appendChild(newForm);
      newForm.submit();
      document.body.removeChild(newForm);
    }
  };

  useEffect(() => {
    const query = QueryString.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (query.accesstoken) {
      const splitToken: string = (query.accesstoken as string).split('/?token')[0];
      window.localStorage.setItem('accessToken', JSON.stringify(splitToken));
      navigate('/myPayReady');
      window.location.reload();
    }
    if (query.app) {
      window.localStorage.setItem('app', JSON.stringify(query.app));
    }
    if (query.payLogo) {
      //@ts-ignore
      const payLogo = JSON.parse(query.payLogo);
      window.localStorage.setItem('paylogo', JSON.stringify(payLogo));
    }
  }, [location]);

  useEffect(() => {
    getRegisterUser()
      .then((res) => {
        setMyPayData(res.data);
        setIsLottie(false);
      })
      .catch((err) => {
        console.error(err);
      });
    const paylogo = getParsedLocalStorageItem('myPayData');
    const paramlogo = getParsedLocalStorageItem('paylogo');
    if (paylogo) {
      setPayLogos(paylogo);
    }
    if (paramlogo) {
      setPayLogos(paramlogo);
    }
  }, [location]);

  useEffect(() => {
    setIsLottie(true);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsLottie(false);
    }, 1000);
  }, []);

  useEffect(() => {
    if (myPayData && paylogos) {
      setTimeout(() => {
        handleSubmit();
      }, 500);
    }
  }, [myPayData, paylogos]);
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          minHeight: '60px',
          padding: '6px 14px',
        }}
      >
        <img
          style={{ width: '24px', height: '24px' }}
          src={`${imgURL}/icon_category_close.png`}
          alt=""
          onClick={() => {
            // goBack();
            handlePostMessage({ actionType: 'goBack' });
            // onClose();
            handlePostMessage({ actionType: 'onClose' });
          }}
        />
      </div>
      <div className="main_wrap">
        <form action={myPayData?.webUrl} method="post" ref={formRef}>
          <input type="hidden" name="birthDay" value={myPayData?.birthDay} />
          <input type="hidden" name="frnYn" value={myPayData?.frnYn} />
          <input type="hidden" name="hCorp" value={myPayData?.hCorp} />
          <input type="hidden" name="mid" value={myPayData?.mid} />
          <input type="hidden" name="returnUrl" value={myPayData?.returnUrl} />
          <input type="hidden" name="signature" value={myPayData?.signature} />
          <input type="hidden" name="socailNo2" value={myPayData?.socailNo2} />
          <input type="hidden" name="userId" value={myPayData?.userId} />
          <input type="hidden" name="userNm" value={myPayData?.userNm} />
          <input type="hidden" name="resetCssUrl" value={`https://shop-api.e-ncp.com${paylogos?.customCssUrl}`} />
          <input type="hidden" name="customTitle" value={paylogos?.payName} />
          <input type="hidden" name="customShortcutUrl" value={'https://shop.aboutfishing.kr/favicon.ico'} />
        </form>
      </div>
    </>
  );
}
